/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：会社汎用定義サービス
 *
 * 作成者：2023/7/18 ノア）馬
 * 最終修正者：2023/7/18 ノア）馬
 *
 */
import { CompanyGeneral, CompanyGeneralRequestParam } from '@/models'
import { setSessionStorage, getSessionStorage } from '@/utils/localStorageUtils'
import { getCompanyGeneralData } from '@/store/apis'

/**
 * 会社汎用定義
 *
 * @readonly
 * @constant
 */
export enum CompanyGeneralType {
  /**
   * ユーザ種類
   */
  USER_ROLE = 'USER_ROLE',
  /**
   * 利用状況
   */
  USAGE_STATUS = 'USAGE_STATUS'
}

const companyGeneral: {
  [companyId: string]: {
    [CompanyGeneralType.USER_ROLE]: CompanyGeneral[] // ユーザ種類
    [CompanyGeneralType.USAGE_STATUS]: CompanyGeneral[] //  利用状況
  }
} = {}

let companyId = ''

const handlerAsync = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async get(target: any, key: any): Promise<any> {
    const sessionStorageKey = companyId.concat(key as string)
    const value = getSessionStorage(sessionStorageKey)
    if (value && value.length > 0) {
      return value
    }

    const generalRequestParam = {
      codeTypeList: [key as string],
      companyId
    } as CompanyGeneralRequestParam
    const res = await getCompanyGeneralData(generalRequestParam)

    if (res && res[key as string]) {
      setSessionStorage(sessionStorageKey, res[key as string])
      Reflect.set(target, key, res[key as string])
      return res[key as string]
    }

    return []
  }
}

const handlerCompanyId = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(target: any, key: any) {
    if (!Object.values(CompanyGeneralType).includes(key)) {
      target = { [key]: {} }
      companyId = key
      return new Proxy(target[key], handlerAsync)
    }
  }
}

export const companyGeneralService = new Proxy(companyGeneral, handlerCompanyId)
